export default __webpack_public_path__ + "static/media/srboiNgirl_w1024.6801028c.jpeg";